module.exports = __webpack_public_path__ + "static/grafika1-acd19a38ee140ea3341d137d345aaa41.png";